import React, { Fragment, useEffect, useState } from 'react';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons';
import cursoricon from "../../../../../../assets/item-click.svg";
import pageview from "../../../../../../assets/page-view.svg";
const NumberStats = ({ data }) => {
    const [totalClick, setTotalClick] = useState(0);

    useEffect(() => {
        if (data !== undefined && data !== null && data.itemClicks !== undefined &&
            data.itemClicks !== null && data.itemClicks.length > 0) {
            var count = 0;
            data.itemClicks.map(i => {
                count += i.clicks;
            });
            setTotalClick(count);
        }
    }, [data]);
    return (
        <Fragment>
            <div className="iconcards-row row d-flex">
                <div className="mb-4 col-md-3">
                    <div className="card">
                        <div className="text-center card-body">
                            <img src={pageview} width="50px" className='mb-2'></img>
                            <p className="card-text font-weight-semibold mb-0"
                                style={{ lineHeight: "17px" }}>
                                Page Views
                            </p>
                            <p className="lead text-center" style={{ fontSize: "1.2rem" }}
                            >{data.avatarClick}
                            </p>
                        </div>

                    </div>
                </div>
                <div className="mb-4 col-md-3">
                    <div className="card">
                        <div className="text-center card-body">
                            <img src={cursoricon} width="50px" className='mb-2'></img>
                            <p className="card-text font-weight-semibold mb-0"
                                style={{ lineHeight: "17px" }}>
                                Spaces Views
                            </p>
                            <p className="lead text-center" style={{ fontSize: "1.2rem" }}
                            >{totalClick}
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default NumberStats;